import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import RadioGroup from "../../structure/RadioGroup";
import { DisabilityEmployerFormValues } from "../../disability/DisabilityEmployerFormValues";
import AddListElementButton from "../../button/AddListElementButton";
import Pay from "../../input/Pay";
import { useAuth } from "oidc-react";
import { EmployerFormValues } from "../../common/EmployerFormValues";
import { PfmlEmployerFormValues } from "../../pfml/PfmlEmployerFormValues";
import { useFormikContext } from "formik";
import { useQuery } from "@apollo/client";
import { VALIDATE_EMPLOYER_REIMBURSEMENT_QUERY } from "../../../Queries";
import { useWageAsOfDate } from "../../../hooks/useWageAsOfDate";
import { findProductFor } from "../../enums/FederationProduct";

const OtherIncome = () => {
    const { initialValues, values } = useFormikContext<EmployerFormValues>();
    const auth = useAuth();

    const { product, payAfterDateLastWorked, policyNumber, privacyId, dateLastWorked } = values as DisabilityEmployerFormValues;
    const { fullPayAfterDateLastWorked, employerReimbursement, workState } = values as PfmlEmployerFormValues;

    const { data: validateEmployerReimbursement } = useQuery(VALIDATE_EMPLOYER_REIMBURSEMENT_QUERY, {
        variables: {
            workState
        },
        skip: !workState
    })
    const stateSupportsReimbursement = validateEmployerReimbursement?.validateEmployerReimbursement

    const federationProduct = findProductFor(product);
    const { data: wageAsOfDateData } = useWageAsOfDate(policyNumber, privacyId, dateLastWorked, federationProduct, dateLastWorked, auth)
    const wageAsOfDate = wageAsOfDateData?.findWageAsOfDate?.wageAsOfDate

    const employerReimbursementSupported = (initialValues as any as PfmlEmployerFormValues)?.employerReimbursement !== undefined
        && fullPayAfterDateLastWorked === 'Yes';
    const employerReimbursementEnabled = employerReimbursementSupported && (employerReimbursement || stateSupportsReimbursement);
    const paidAfterDateLastWorked = payAfterDateLastWorked === 'Yes';
    return (
        <QuestionPanel headerText="Is your employee receiving any other income?"
                       detailsText={<div>
                           If the amount reflected does not accurately represent the employee's earnings, please upload a W-2 or paystubs as
                           supporting documentation.
                       </div>}
                       panelContent={<>
                           <div>
                                       <RadioGroup id="pay-after-date-last-worked"
                                                   label={`Will your employee receive any type of pay for time after ${wageAsOfDate}?`}
                                                   required={true}
                                                   radioProps={[
                                                       {id: "yes", text: "Yes"},
                                                       {id: "no", text: "No"}
                                                   ]}/>
                                       {paidAfterDateLastWorked
                                           && <>
                                               <RadioGroup id="full-pay-after-date-last-worked"
                                                           label={`Is your employee receiving full pay after ${dateLastWorked}?`}
                                                           required={true}
                                                           radioProps={[
                                                               { id: "yes", text: "Yes" },
                                                               { id: "no", text: "No" }
                                                           ]}/>
                                   <AddListElementButton idPrefix="pay-types-after-date-last-worked"
                                                         buttonText="Add Pay"
                                                         componentType={Pay}
                                                         elementInitialValue={{ payType: '', startDate: '', endDate: '', totalHoursPaid: '', percentagePaid: '', estimateAmount: '', incorrectEstimate: false, amount: '' }}
                                                         label={(initialValues as DisabilityEmployerFormValues)?.payTypesAfterDateLastWorked
                                                             ? "Please provide the employee's pay types and timeframe."
                                                             : ""}/>
                           </>}
                               {employerReimbursementEnabled
                                   && <RadioGroup id="employer-reimbursement"
                                                  label={`Will you (the policyholder) be requesting reimbursement for wages paid after ${dateLastWorked}?`}
                                                  required={true}
                                                  radioProps={[{ id: "yes", text: "Yes" }, {
                                                      id: "no",
                                                      text: "No"
                                                  }]}/>
                               }
                           </div>
                       </>}>
        </QuestionPanel>
    )
};

export default OtherIncome;